import {
    Component,
    ViewChild,
    TemplateRef,
    AfterViewInit,
    ChangeDetectorRef,
    ElementRef,
    OnDestroy,
  } from "@angular/core";
  import {
    MatRowDef,
    MatTableModule,
  } from "@angular/material/table";
  import { MatDialogModule, MatDialog, MatDialogRef } from "@angular/material/dialog";
  import { CommonModule } from "@angular/common";
  import { MatButtonModule } from "@angular/material/button";
  import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
  import { MatFormFieldModule } from "@angular/material/form-field";
  import { MatInputModule } from "@angular/material/input";
  import {
    MatPaginator,
    MatPaginatorIntl,
    MatPaginatorModule,
    PageEvent,
  } from "@angular/material/paginator";
  import { MatSort, MatSortModule } from "@angular/material/sort";
  import { MatSelectModule } from "@angular/material/select";
  import { MatIcon, MatIconModule } from "@angular/material/icon";
  import { MatSlideToggle } from "@angular/material/slide-toggle";
  import { MatOptionModule } from "@angular/material/core";
  import { MatTooltipModule } from "@angular/material/tooltip";
  import { MatExpansionModule } from "@angular/material/expansion";
  import { MatSnackBar } from "@angular/material/snack-bar";
  import { MatSidenavContainer } from "@angular/material/sidenav";
  import { MatMenuModule } from "@angular/material/menu";
  import { MatTabsModule } from "@angular/material/tabs";
  import {
    NgSelectModule,
  } from "@ng-select/ng-select";
import { ICreatePriceList } from "./interfaces/create-price-list.interface";
import PriceListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/price-list/price-list.entity";
import { PriceListService } from "./price-list.service";
import { IUpdatePriceList } from "./interfaces/update-price-list.interface";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from 'app/utils/method';
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { PriceListExport } from "./exports/price-list.export";
import { PRICE_LIST_TITLE } from "./exports/price-list.constants";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { AddCustomersPricelistComponentComponent } from "./modals/add-customers-pricelist-component/add-customers-pricelist-component.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";


  @Component({
    selector: "app-price-list",
    templateUrl: "./price-list.component.html",
    styleUrls: ["./price-list.component.scss"],
    standalone: true,
    imports: [
      CommonModule,
      MatTableModule,
      MatDialogModule,
      MatButtonModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatInputModule,
      MatSortModule,
      MatPaginatorModule,
      MatIcon,
      MatSlideToggle,
      MatSelectModule,
      MatOptionModule,
      MatTooltipModule,
      MatExpansionModule,
      MatMenuModule,
      MatButtonModule,
      MatIconModule,
      MatRowDef,
      MatSidenavContainer,
      FormsModule,
      NgSelectModule,
      HoverMenuDirective,
      MatTabsModule,
      FilterComponent,
      StatusFiltersComponent,
      ConfigurationFiltersComponent,
      AddCustomersPricelistComponentComponent
    ],
    providers: [
      { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
      PriceListExport
    ],
  })
  export class PriceListComponent implements AfterViewInit, OnDestroy {
    getCode = getCode;
    displayedColumns: string[] = ["name", "type", "status", "actions"];
    currentCreatePriceList: ICreatePriceList =
      this.initializeCreatePriceList();
    currentUpdatePriceList: PriceListAttributes | undefined;
    typeList : { valor: string; label: string }[] = [
        { valor: 'D', label: 'DESCUENTO' },
        { valor: 'P', label: 'PRECIO' },
        { valor: 'G', label: 'PROMOCIÓN'}
      ];

    dataSource: PriceListAttributes[] = [];
  
    filter = {
      type: null
    }

    searchQuery: string = "";
    totalItems: number = 0;
    pageSize: number = 50;
    pageIndex: number = 1;

    dialogRefAdd: MatDialogRef<any>;
    dialogRefEdit:MatDialogRef<any>;
    dialogRefAddClient: MatDialogRef<any>;
  
    @ViewChild("editModal") editModal!: TemplateRef<any>;
    @ViewChild("addModal") addModal!: TemplateRef<any>;
    @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
    @ViewChild("addClienteModal") addClienteModal!: TemplateRef<any>;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild("searchInput") searchInput!: ElementRef;
  
    //BUSCADOR
    searchSubscription: Subscription;

    form: FormGroup;
    
    selectedStatuses: [] = [];

    priceListIdSelected : string;
    
    constructor(
      private readonly priceList: PriceListService,
      private readonly searchService: SearchService,
      private dialog: MatDialog,
      private snackBar: MatSnackBar,
      private cdr: ChangeDetectorRef,
      public exportService: ExportService,
      private priceListExport: PriceListExport,
      private fb: FormBuilder
    ) {
      this.form = this.fb.group({
        companyId: [null]
      });
    }
  
    ngAfterViewInit(): void {
      this.onHandleSearch();
      this.setupPaginationAndSorting();
      this.onFilter();
    }
  
    private initializeCreatePriceList(): ICreatePriceList {
      return { name: "", code:"", type: "", isPromotion: false };
    }
  
    private setupPaginationAndSorting(): void {
      this.paginator.page.subscribe(() => this.findAllWithCount());
      this.sort.sortChange.subscribe(() => {
        this.paginator.pageIndex = 0;
        this.findAllWithCount();
      });
    }  

    onFilter(){
      this.findAllWithCount()
    }

    onClearFilter(){
      this.selectedStatuses = [];
      this.filter = {
        type: null
      }

      this.onFilter()
    }

    findAllWithCount(): void {
      // const pageIndex = this.paginator.pageIndex + 1;
      const sortField = this.getSortField();
      const sortDirection: "ASC" | "DESC" =
        this.sort.direction === "asc" ? "ASC" : "DESC";
  
      this.priceList
        .findAllWithCount({
          currentPage: this.pageIndex,
          limitPerPage: this.pageSize,
          search: this.searchQuery,
          sort: sortField,
          sortDirection: sortDirection,
        }, this.filter, this.selectedStatuses)
        .subscribe((data) => {
          this.dataSource = data?.data?.[0]?.data ?? [];
          this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
          this.paginator.length = this.totalItems;
        });
    }
  
    private getSortField(): keyof PriceListAttributes {
      const validSortFields: (keyof PriceListAttributes)[] = [
        "name",
        "statusId",
      ];
      return validSortFields.includes(
        this.sort.active as keyof PriceListAttributes
      )
        ? (this.sort.active as keyof PriceListAttributes)
        : "name";
    }
  
    onPageChange(event: PageEvent): void {
      this.pageSize = event.pageSize;
      this.pageIndex = event.pageIndex + 1;
      this.findAllWithCount();
    }
  
    onSearchChange(event: Event): void {
      const input = event.target as HTMLInputElement;
      this.searchQuery = input.value.trim();
      if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
        // this.paginator.pageIndex = 0;
        this.findAllWithCount();
      }
    }

    public onHandleSearch(){
      this.searchSubscription = this.searchService.searchTerm$
        .subscribe(term => {
          this.searchQuery = term
          if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
            // this.paginator.pageIndex = 0;
            this.findAllWithCount();
          }
        });
    }
    
    trackByFn(index: number, item: PriceListAttributes): string {
      return item._id.toString();
    }
  
    getName(value: string): string {
      const item = this.typeList.find(type => type.valor === value);
      return item ? item.label : value;
    }    

    openCreateModal(): void {
      this.currentCreatePriceList = this.initializeCreatePriceList();
      this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose:true })
      // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createPriceList());
      this.dialogRefAdd.afterClosed().subscribe((result) => { result });
    }
  
    openEditModal(unit: PriceListAttributes): void {
        this.currentUpdatePriceList = { ...unit };
      this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose:true })
      // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updatePriceList(unit._id.toString()));
      this.dialogRefEdit.afterClosed().subscribe((result) => { result });
    }


    openAddClientModal(price: PriceListAttributes): void {
      this.priceListIdSelected = price._id.toString();
      this.dialogRefAddClient = this.dialog.open(this.addClienteModal, { 
        panelClass: "form-modal", 
        disableClose: true 
      });
      this.dialogRefAddClient.afterClosed().subscribe((result) => { 
        result 
      });
    }
  
    createPriceList(): void {
      this.priceList.create(this.currentCreatePriceList).subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefAdd.close()
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  
    updatePriceList(id: string): void {
      if (this.currentUpdatePriceList) {
        const updatedPriceList: IUpdatePriceList = {
          ...this.currentUpdatePriceList,
        };
  
        this.priceList.update(id, updatedPriceList).subscribe({
          next: () => {
            this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
              duration: 3000,
            });
            this.findAllWithCount();
            this.dialogRefEdit.close();
          },
          error: (err) => {
            this.snackBar.open(
              err.error.message || "Error al actualizar el registro",
              "Cerrar",
              { duration: 3000 }
            );
          },
        });
      }
    }
  
    onStatusChange(event: boolean, unit: PriceListAttributes): void {
      const originalStatusId = unit.statusId;
      const updatedStatusId = event ? 1 : 0;
      const updatedPriceList = { ...unit, statusId: updatedStatusId };
  
      this.priceList
        .update(unit._id.toString(), updatedPriceList)
        .subscribe({
          next: () => {
            this.findAllWithCount();
          },
          error: () => {
            unit.statusId = originalStatusId; // Volver al estado original si falla
            this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
              duration: 3000,
            });
            this.findAllWithCount();
          },
        });
    }
  
    openDeleteDialog(unit: PriceListAttributes): void {
      this.dialog
        .open(this.deleteDialog, { data: unit, panelClass: "delete-modal", disableClose:true })
        .afterClosed()
        .subscribe((result) => result && this.delete(unit._id.toString()));
    }
  
    delete(id: string): void {
      this.priceList.remove(id).subscribe(() => {
        this.findAllWithCount();
        this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
          duration: 3000,
        });
      });
    }

  onExportButtonPressed() {
    if (!this.priceListExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: PRICE_LIST_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.priceListExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
  